import React from 'react'
import Style1 from '../Assets/images/style1.jpg'
import Style2 from '../Assets/images/style2.jpeg'
import Style3 from '../Assets/images/style3.png'
import Style4 from '../Assets/images/style4.png'
import Style5 from '../Assets/images/style5.jpeg'
import Style6 from '../Assets/images/style6.jpeg'
import Style7 from '../Assets/images/style7.jpeg'
import Style8 from '../Assets/images/style8.jpeg'
import Style9 from '../Assets/images/style9.jpg'
import Style10 from '../Assets/images/style10.jpg'
import Style11 from '../Assets/images/style11.jpeg'
import Style12 from '../Assets/images/style12.jpeg'
import Style13 from '../Assets/images/style13.jpeg'
import Style14 from '../Assets/images/style14.jpeg'


function MoreStyle() {
  return (
    <div>
        <section className="mainSection ">
            <div className="container gdfgh">
                <div className="row ">
                <div className='col-12 text-align-center mb-50'>
                        <h2 className='title'>All Styles</h2>
                        <h5 className='subText'> Selected image will be used for NFT 1 minting .</h5>
                    </div>
                    <div className='col-md-12 col-sm-12'>
                    <ul className='styleImgSection'>
                        <li>
                            <a href="#">
                                <img src={Style1}/>
                                <p>steampunk</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style2}/>
                                <p>3d-objects</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style3}/>
                                <p>pixel</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style4}/>
                                <p>watercolor</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style5}/>
                                <p>future-architecture</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style6}/>
                                <p>fantasy-character</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style7}/>
                                <p>logo</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style8}/>
                                <p>diffusion</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style9}/>
                                <p>creature</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style10}/>
                                <p>surreal</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style11}/>
                                <p>contemporary-architecture</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style12}/>
                                <p>fantasy-character</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style13}/>
                                <p>pop-art</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={Style14}/>
                                <p>3d-origami</p>
                            </a>
                        </li>

                        


                    </ul>

                    </div>
                </div>
            </div>
        </section>       
    </div>
  )
}

export default MoreStyle